var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer28(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 42.446,
    viewBox: "0 0 36 42.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer28",
    transform: "translate(-0.95 -0.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LINE-4",
    d: "M21.42.844l-7.387,7.39a3.032,3.032,0,0,0-4.143.111L8.7,9.524a3.033,3.033,0,0,0-.107,4.151L1.214,21.054a1.012,1.012,0,0,0,1.428,1.428L7.326,17.8a2.89,2.89,0,0,0,.016.391L10.77,40.408a3.041,3.041,0,0,0,3,2.565H30.5A3.037,3.037,0,0,0,33.5,40.408l3.417-22.219a3.051,3.051,0,0,0-3-3.488h-.959l-1.784-5.37a1.01,1.01,0,0,0-1.417-.584l-3.579,1.791L22.584,8.747a1.048,1.048,0,0,0-1.121.134L14.756,14.7H10.423L22.852,2.276A1.013,1.013,0,1,0,21.42.844ZM12.6,9.666l-2.569,2.573a.984.984,0,0,1,.1-1.282l1.176-1.2a.954.954,0,0,1,1.29-.095Zm9.687,1.184,3.429,1.716a1.01,1.01,0,0,0,.911,0l3-1.492L30.835,14.7H17.853ZM10.34,16.713H33.917a.991.991,0,0,1,1,1.164L31.5,40.1a1.006,1.006,0,0,1-1,.864H13.769a1.006,1.006,0,0,1-1-.864L9.338,17.877a.994.994,0,0,1,1-1.164Zm6.739,9.1v8.085a1.01,1.01,0,1,0,2.012,0V25.808A1.006,1.006,0,1,0,17.08,25.808Zm8.085,0v8.085a1.01,1.01,0,1,0,2.012,0V25.808A1.006,1.006,0,1,0,25.165,25.808Z",
    transform: "translate(0 0)",
    fill: "#cb324c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer28);
export default __webpack_public_path__ + "static/media/layer28.24db3771.svg";
export { ForwardRef as ReactComponent };